import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PurchaseProcessView } from "src/components/views/erp/purchase/purchaseProcessView/PurchaseProcessView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/purchase/processView")({
	staticData: { title: i18n.t("purchase_process_view"), legacyViewKey: "purchaseProcessViewPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <PurchaseProcessView />;
}
